import { Button, Grid } from "@mui/material";
import { useTranslation } from "react-i18next";
import BasicDialog from "../../../../../components/base/BasicDialog";
import { usePaymentSchedules } from "../../../../../services/agreementsService";

export const ScheduleTemplateSelectionDialog = (props) => {
    const { onClose, selectedTemplateId, onTemplateSelect } = props;
    const { t } = useTranslation();

    const { data: scheduleTemplates } = usePaymentSchedules();

    const handleSelectTemplate = (templateId) => {
        onTemplateSelect(templateId);
        onClose();
    };

    return (
        <BasicDialog
            open={props.open}
            onClose={props.onClose}
            titleAlign={"center"}
            contentAlign={"center"}
            title={t("agreements.ScheduleTemplateSelectionDialog.title")}
            minWidth={800}
            maxWidth={"xl"}
            showDialogActions
        >
            <Grid container spacing={2}>
                {scheduleTemplates?.map((template) => (
                    <Grid item xs={12}>
                        <Button
                            key={template.id}
                            onClick={() => handleSelectTemplate(template.id)}
                            disabled={selectedTemplateId === template.id}
                        >
                            {template.schedule_name}
                        </Button>
                    </Grid>
                ))}
            </Grid>
        </BasicDialog>
    );
};
